module.exports = __webpack_public_path__ + "img/coin.c345cfd5.png";